import { map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService, UserService } from '../services'

@Component({
    template: `<div></div>`
})
export class DefaultRouter implements OnInit {
    constructor(private router: Router, private tenantService: TenantService, private userService:UserService){}
    ngOnInit() {
        this.userService.isLoggedIn().pipe(
            mergeMap(status => !!status.user ? of(null) : this.tenantService.getUnauthTenantInfo()),
            map(tenant => {
                if (tenant?.settings?.sharedManagementEnabled === 'true') {
                    return '/settings/shared/catalogs';
                } else if (tenant?.settings?.publicTopics === 'true') {
                    return '/browse';
                } else {
                    return '/digest/recent';
                }
            })
        )
        .subscribe(url => this.router.navigateByUrl(url));
    };
}
